<template>
  <div style="height: 100%">
    <gj-table
        name="storageArgs"
        adaptParent
        :data="tableData"
        :columns="columns"
        :loading="loading"
        :show-overflow="false"
    >
      <template v-slot:content="{ row }">
        <template v-if="row.name === 'INVENTORY_UNSALABLE_ALERT'">
          <gj-select
              v-model="row.content"
              :options="[
               {id: '30', text: '30天以上库龄'},
                {id: '60', text: '60天以上库龄'},
                {id: '90', text: '90天以上库龄'},
                {id: '180', text: '180天以上库龄'},
                {id: '270', text: '270天以上库龄'},
                {id: '365', text: '365天以上库龄'}
              ]"
              :clearable="false"
              width="200px"
              @input="updateConfig($event, row)">
          </gj-select>
        </template>
      </template>
    </gj-table>
  </div>
</template>

<script>
  import {queryMixin, responseMixin} from "../../../../../../minxins";
  import {getStorageArgs, updateStorageArgs} from "../../../../../../api/setting";
  import {isMeaningful} from "../../../../../../utils/common";

  export default {
    name: "app-storage-args",
    mixins: [queryMixin, responseMixin],
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'name', header: '库存指标', field: 'option:name', minWidth: '200px', options: [
              {id: 'INVENTORY_UNSALABLE_ALERT', text: '滞销库龄区间'}
            ]},
          {id: 'content', header: '配置项', field: 'slot:content', minWidth: '200px'},
          {id: 'memo', header: '指标配置说明', field: 'memo', minWidth: '400px'},
          {id: 'updateTime', header: '更新时间', field: 'updateTime', width: '200px'},
        ],
      }
    },
    methods: {
      updateConfig(content, row) {
        updateStorageArgs({
          id: row.id,
          content,
          memo: row.memo
        })
          .then((res) => {
            this.$gjResponseHandle(res, () => {
               this.$gjMessage.success('更新成功');
            });
          });
      },
      $gjQuery() {
        // 查询
        this.loading = true;
        getStorageArgs()
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = data;
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          });
      },
    }
  }
</script>

<style scoped>

</style>

